export const fmtMoney = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return "$" + Number(n).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const STATUS_STYLES = {
  "COMPLIANT": {
    label: "COMPLIANT",
    text: "text-success",
    bg: "bg-success-soft",
    border: "border-success/30",
    dot: "bg-success",
  },
  "INCOMPLETE": {
    label: "INCOMPLETE",
    text: "text-warning",
    bg: "bg-warning-soft",
    border: "border-warning/30",
    dot: "bg-warning",
  },
  "MISSING ALLTOGETHER": {
    label: "MISSING",
    text: "text-destructive",
    bg: "bg-destructive-soft",
    border: "border-destructive/30",
    dot: "bg-destructive",
  },
  "NOT STATED": {
    label: "NOT STATED",
    text: "text-warning",
    bg: "bg-warning-soft",
    border: "border-warning/30",
    dot: "bg-warning",
  },
  "DISCLOSED": {
    label: "DISCLOSED — REVIEW",
    text: "text-warning",
    bg: "bg-warning-soft",
    border: "border-warning/30",
    dot: "bg-warning",
  },
  "NOT APPLICABLE": {
    label: "N/A",
    text: "text-success",
    bg: "bg-success-soft",
    border: "border-success/30",
    dot: "bg-success",
  },
  "NOT DISCLOSED": {
    label: "NOT DISCLOSED",
    text: "text-warning",
    bg: "bg-warning-soft",
    border: "border-warning/30",
    dot: "bg-warning",
  },
};

export const scoreColor = (score) => {
  if (score >= 90) return "#10b981";
  if (score >= 70) return "#eab308";
  return "#f43f5e";
};
